import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  model,
  OnInit,
} from '@angular/core';
import { CyloginService, LoginComponent } from '@auth';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { APIService } from '@core/services/api.service';
import { filter, forkJoin } from 'rxjs';
import { Profile, Role } from '@core/interfaces';
import { HttpParams } from '@angular/common/http';
import { Roles } from '@auth';
import { browserRefresh } from '@app/app';
import { CookieService } from 'ngx-cookie-service';
import { ButtonComponent } from '@shared/components';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService, Translation } from '@ngx-translate/core';
import { assets } from '@core/constants';
import { NgComponentOutlet } from '@angular/common';
import { ProgressSpinner } from 'primeng/progressspinner';

@UntilDestroy()
@Component({
  selector: 'ncp-home',
  imports: [ButtonComponent, NgComponentOutlet, ProgressSpinner],
  providers: [CookieService],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, AfterViewInit {
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private cookieService = inject(CookieService);
  private cyLoginService = inject(CyloginService);
  private apiService = inject(APIService);
  private _isLoggingIn: boolean = false;
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private readonly translate = inject(TranslateService);
  protected translations!: Translation;
  protected readonly nationalSrc = assets.img.home.national.src;
  protected readonly europeanSrc = assets.img.home.european.src;
  protected readonly profileSrc = assets.img.home.profile.src;

  protected profile = model<Profile>();

  get isLoggingIn() {
    return this._isLoggingIn;
  }

  set isLoggingIn(isLoggingIn: boolean) {
    this._isLoggingIn = isLoggingIn;
  }

  ngOnInit() {
    this.translations = this.translate.instant('home');
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('home');
    });

    if (JSON.parse(sessionStorage.getItem('profile')!)) {
      this.profile.set(JSON.parse(sessionStorage.getItem('profile')!) as Profile);
    }

    sessionStorage.removeItem('pToken');

    //if(sessionStorage.getItem())

    if (browserRefresh()) {
      // For development only
      const subscription = this.cyLoginService.isAuthenticated().subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.apiService
            .callMany(
              [{ path: '/profile', name: 'profile' }],
              [
                {
                  path: 'logoutURL',
                  observable: this.cyLoginService.getSessionClaim('bff:logout_url'),
                },
              ]
            )
            ?.subscribe((res) => {
              if (res && res['profile'] && res['logoutURL']) {
                this.profile.set(res['profile'] as Profile);
                //profile.details.isPharmacyOwner = false;

                sessionStorage.setItem('profile', JSON.stringify(res['profile']));
                sessionStorage.setItem('logout_url', res['logoutURL'] as string); // + '&returnUrl=/api/logged-out');

                subscription.unsubscribe();
                browserRefresh.set(false);
                this.goToInitialPage();
              }
            });
        } else {
          this.router.navigate(['/']);
        }
      });
    } else {
      this.route.queryParamMap.subscribe((params) => {
        const success = params.get('s');
        if (params.has('s') && params.get('s') === 'true') {
          this.isLoggingIn = true;
          const subscription = this.cyLoginService
            .isAuthenticated()
            .subscribe((isAuthenticated) => {
              if (isAuthenticated) {
                this.apiService
                  .callMany(
                    [{ path: '/profile', name: 'profile' }],
                    [
                      {
                        path: 'logoutURL',
                        observable: this.cyLoginService.getSessionClaim('bff:logout_url'),
                      },
                    ]
                  )
                  ?.subscribe((res) => {
                    if (res && res['profile'] && res['logoutURL']) {
                      this.isLoggingIn = false;
                      this.profile.set(res['profile'] as Profile);

                      sessionStorage.setItem('profile', JSON.stringify(res['profile']));
                      sessionStorage.setItem('logout_url', res['logoutURL'] as string); // + '&returnUrl=/api/logged-out');

                      subscription.unsubscribe();
                      this.goToInitialPage();
                    }
                  });
              } else {
                this.router.navigate(['/']);
              }
            });
        } else {
          this.goToInitialPage();
        }
      });
    }
  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  goToInitialPage(): void {
    if (this.profile()) {
      switch (this.profile()?.role.toString()) {
        case Roles.physician:
          {
            this.router.navigate(['/']);
          }
          break;
        case Roles.pharmacist:
          {
          }
          break;
        default: {
          this.router.navigate(['/noaccess']);
        }
      }
    } else {
      //this.profile.set(undefined);
      this.router.navigate(['/']);
    }
  }

  protected goToCY = () => {
    this.router.navigate(['cy']);
  };

  protected goToEU = () => {
    this.router.navigate(['eu']);
  };

  protected goToProfile = () => {};

  protected readonly sessionStorage = sessionStorage;
  protected readonly LoginComponent = LoginComponent;
}
